export default __webpack_public_path__ + "static/media/biz_booking_icon_collab.bcffcd55.svg";